import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Button } from '../shared/ui/Button';

export class AppErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) { return { error }; }
  componentDidCatch(error: Error, info: ErrorInfo) { console.error('V4 application error', error, info); }
  render() {
    if (!this.state.error) return this.props.children;
    return <main className="standalone-state"><section className="v4-card error-boundary"><span>系统保护</span><h1>页面遇到了意外问题</h1><p>{this.state.error.message}</p><Button onClick={() => window.location.assign('/')}>重新进入系统</Button></section></main>;
  }
}
